import React, { useEffect, useState } from 'react';
import { ShieldCheck, Trash2, Plus, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { AdminAPI } from '../../api';

export const AdminsPanel = () => {
  const [data, setData] = useState(null);
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const load = () => AdminAPI.admins().then(setData).catch(() => toast.error('Failed to load admins'));
  useEffect(() => { load(); }, []);

  const add = async () => {
    setSaving(true);
    try { await AdminAPI.addAdmin(email.trim()); setEmail(''); load(); toast.success('Admin added'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Could not add admin'); } finally { setSaving(false); }
  };
  const remove = async (e2) => {
    if (!window.confirm(`Remove admin access for ${e2}?`)) return;
    try { await AdminAPI.removeAdmin(e2); load(); toast.success('Admin removed'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Could not remove admin'); }
  };

  if (!data) return <div className="text-[13px] text-[#6F76A7]">Loading…</div>;
  const total = data.admins.length;

  return (
    <div className="max-w-[640px]" data-testid="admins-panel">
      <p className="text-[13px] text-[#6F76A7] mb-4">{data.bootstrap.length} built-in admin account{data.bootstrap.length === 1 ? '' : 's'} (set in configuration, cannot be removed here) plus {total} of {data.max} invited admin seats used. Admins see every agreement, every user, the activity log and this page.</p>
      <div className="bg-white border border-[#E3E5F5] rounded-xl divide-y divide-[#F0F1FB]">
        {data.bootstrap.map((e2) => (
          <div key={e2} className="flex items-center gap-3 px-4 py-3" data-testid={`admin-primary-${e2}`}>
            <ShieldCheck className="w-4 h-4 text-[#0F766E] shrink-0" />
            <span className="text-[14px] text-[#0A1551] truncate flex-1">{e2}</span>
            <span className="inline-flex items-center gap-1 text-[12px] text-[#6F76A7]"><Lock className="w-3 h-3" /> Primary</span>
          </div>
        ))}
        {data.admins.map((a) => (
          <div key={a.email} className="flex items-center gap-3 px-4 py-3" data-testid={`admin-row-${a.email}`}>
            <ShieldCheck className="w-4 h-4 text-[#0F766E] shrink-0" />
            <span className="text-[14px] text-[#0A1551] truncate flex-1">{a.email}</span>
            <button onClick={() => remove(a.email)} data-testid={`admin-remove-${a.email}`} className="p-1.5 rounded hover:bg-[#FEF2F2] text-[#E5387B]" aria-label={`Remove ${a.email}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      {total < data.max && (
        <div className="flex flex-col sm:flex-row gap-2 mt-4">
          <input value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && email.trim()) add(); }}
            placeholder="teammate@company.com" data-testid="admin-email-input"
            className="flex-1 px-3 py-2.5 border border-[#D5D7ED] rounded-md text-[14px] text-[#0A1551] focus:outline-none focus:border-[#0A1551]" />
          <button onClick={add} disabled={!email.trim() || saving} data-testid="admin-add-button"
            className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-[#0F766E] hover:bg-[#0B5F58] text-white text-[14px] font-semibold disabled:opacity-50">
            <Plus className="w-4 h-4" /> Add admin
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminsPanel;
